import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { LinkedRecordViewModel } from "../domain/LinkedRecordViewModel";
import { removeLinkedRecord } from "../redux/actions";

export type RemoveLinkedRecordDialogProps = {
  entityReferenceId: string;
  linkedRecord: LinkedRecordViewModel;
  isDialogOpen: boolean;
  onClose: () => void;
};

export const RemoveLinkedRecordDialog: React.FC<RemoveLinkedRecordDialogProps> = ({
  entityReferenceId,
  linkedRecord,
  isDialogOpen,
  onClose,
}) => {
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(removeLinkedRecord(linkedRecord.id, entityReferenceId));
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog maxWidth="md" fullWidth open={isDialogOpen} onClose={onClose}>
        <DialogTitle>
          Are you sure you want to remove the linked record{" "}
          {linkedRecord.linkedEntityTitle}?
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            data-test="cancel-remove-link"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            data-test="confirm-remove-link"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
